import { Pipe, PipeTransform } from '@angular/core';
import { PhotonFeatureDTO } from '../model/dto/PhotonFeatureDTO';

export type TransformedPhotonFeature = {
    street: string;
    addr: string;
    lat: number;
    lng: number;
    district: string;
    city: string;
    // telemetria (geocode-obs-v2): tier de precisão do Photon, para testar H1 (rooftop × centroide)
    geo_type?: string;
    geo_osm_key?: string;
    geo_osm_value?: string;
};

@Pipe({
    name: 'geocodeToAddress',
})
export class GeocodeToAddress implements PipeTransform {
    constructor() {}

    transform(feature: PhotonFeatureDTO): TransformedPhotonFeature {
        const [lng, lat] = feature.geometry.coordinates;
        const { name, district, city, state, country, type, osm_key, osm_value } = feature.properties;

        const address = [district, city, state, country].filter(Boolean).join(', ');

        return {
            street: name,
            addr: address,
            lat,
            lng,
            district,
            city,
            geo_type: type,
            geo_osm_key: osm_key,
            geo_osm_value: osm_value,
        };
    }
}
